let mapsPromise;
export function loadGoogleMaps(key) {
  if (window.google?.maps) return Promise.resolve(true);
  if (mapsPromise) return mapsPromise;

  // Preconnects make first load faster
  ["https://maps.googleapis.com", "https://maps.gstatic.com", "https://fonts.gstatic.com"]
    .forEach(href => {
      const l = document.createElement("link");
      l.rel = "preconnect"; l.href = href; l.crossOrigin = "";
      document.head.appendChild(l);
    });

  mapsPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&v=weekly`;
    s.async = true; s.defer = true;
    let done = false;
    const finish = ok => { if (!done) { done = true; resolve(ok); } };
    s.onload = () => finish(true);
    s.onerror = () => finish(false);
    document.head.appendChild(s);
    // 8s hard timeout; don’t ever wait 60s
    setTimeout(() => finish(!!window.google?.maps), 8000);
  });

  return mapsPromise;
}
